module.exports = __webpack_public_path__ + "img/book_cover.dcab3c98.png";